import React from 'react';

export default function template(context) {
  const calc = context.calc,
    model = calc.state.model,
    isMobile = calc.isViewportMobile(),
    termBtns = (
      <div className="calculator-terms-wrapper">
        {[2, 13, 24].map((item, index) => {
          return (
            <button className={`term-btn ${item === Number(model.getCreditTerm()) ? 'active' : ''}`} name="shopCreditTerm" key={item} onClick={calc.handleChange3} data-min={model.getMinTermEdge()} data-max={model.getMaxTermEdge()} value={item}>{item}</button>
          )
        })}
      </div>
    ),
    amountBtns = (
      <div className="calculator-amount-wrapper">
        {['300', '100000', '200000'].map((item, index) => {
          return (
            <button className={`amount-btn ${+item === Number(model.getCreditSum()) ? 'active' : ''}`} name="creditSum" key={index} onClick={calc.handleChange} value={item}>
              {(+item).toLocaleString() + ' ' + calc.l10n('UAH_ICON')}
            </button>
          )
        })}
      </div>
    ),
    error = calc.state.error
      ? (<div className="error-text">{`${calc.l10n("CALCULATOR_CREDIT_ERROR_TEXT")} ${model.getMinSumEdge()} ${calc.l10n('UAH_ICON')}`}</div>)
      : '';

  return (
    <React.Fragment>
      <div className="calculator-controllers">
        <div className="calc-title">{calc.l10n('CREDIT_INSTALLMENT_CALC')}</div>
        <div className="calc-mode-description">
          {calc.l10n("INSTALLMENT_FROM_STATEMENT_CALC_SUBTITLE")}
          <div className="green">{model.getMonthCommission() + calc.l10n("PERCENT")}</div>
        </div>
        <div className={`controller-block ${calc.state.error ? 'error' : ''}`}>
          <div className="calc-block-title">
            {calc.l10n('CREDIT_PBP_SUM')}
            {isMobile ? <br/> : ''}
            <span className="calc-block-title-sum">
            {` (${calc.l10n('CALCULATOR_CREDIT_SUM_FROM')} ${model.getMinSumEdge()} ${calc.l10n('CALCULATOR_CREDIT_SUM_TO')} ${model.getMaxSumEdge().toLocaleString()} ${calc.l10n('UAH_ICON')})`}
          </span>
          </div>
          <div className="calculator-slider-wrapper">
            <div className="calculator-input-wrapper">
              <input name="creditSum" type="text"
                     className="calculator-slider-value"
                     value={model.getCreditSum().toLocaleString('uk-UA')}
                     onChange={calc.handleChangeInput}
                     onBlur={calc.blurChangeInput}
                     max={model.getMaxSumEdge()}
                     min={model.getMinSumEdge()}>
              </input>
              <span ref={calc.hiddenValue} className='hidden-value'>{model.getCreditSum().toLocaleString('uk-UA')}</span>
              <span style={{left: `${calc.state.valueWith}px`}}>{calc.l10n('UAH_ICON')}</span>
            </div>
          </div>
          <input type="range"
                 name="creditSum"
                 className="calculator-sum-slide"
                 onChange={calc.handleChange4}
                 value={model.getCreditSum()}
                 min={model.getMinSumEdge()}
                 max={model.getMaxSumEdge()}
                 step={model.getSumStep()}
                 style={{background: `linear-gradient(90deg, #4BDF7F ${calc.state.rangePercent}%, transparent ${calc.state.rangePercent}%)`}}
          />
        </div>
        {error}
        {amountBtns}
        <div className="controller-block">
            <div className="calc-block-title">
                {calc.l10n('INSTALLMENT_FROM_STATEMENT_CALC_TERMS_PAYMENT')}
            </div>
            <div className="calculator-slider-wrapper">
                <div className="calculator-input-wrapper">
                    <input name="shopCreditTerm" type="text"
                            className="calculator-slider-value"
                            value={model.getCreditTerm()}
                            // onChange={calc.handleChangeInput}
                            readOnly ={true}
                            min={model.getMinTermEdge()}
                            max={model.getMaxTermEdge()}
                    >
                    </input>
                </div>
            </div>
            <input type="range"
                        name="shopCreditTerm"
                        className="calculator-sum-slide"
                        onChange={calc.handleChange3}
                        value={model.getCreditTerm()}
                        min={model.getMinTermEdge()}
                        max={model.getMaxTermEdge()}
                        step="1"
                        style={{background: `linear-gradient(90deg, #4BDF7F ${calc.state.rangePercent1}%, transparent ${calc.state.rangePercent1}%)`}}
                />
        </div>
        {termBtns}
      </div>
    </React.Fragment>
  );
}